export enum JobSimilarity {
  Employer = 'employer',
  Salary = 'salary',
  Distance = 'distance',
}
